import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Keyable from '../../../../types/keyable';
import immaHelpers from '../../../../common/redux/immaHelpers';
import httpErrorHandling from '../../../../utils/httpErrorHandling';
import { confirmMediaStep } from './mediaRequest';
import { OnboardingStepState } from '../../onboardingSlice';
import { ImageInfo } from '../../../../common/interfaces/ImageInfo';

export interface VideoMedia extends Keyable {
  value: string;
}

export interface AdditionalMedia {
  groupId: string;
  image: ImageInfo;
  description?: string;
}

export interface MediaState {
  profile?: ImageInfo | null;
  additional: AdditionalMedia[];
  instagram: string;
  videos: VideoMedia[];
}

const initialState: MediaState & OnboardingStepState = {
  inProgress: false,
  isDone: false,
  doRedirectFurther: false,
  profile: null,
  additional: [],
  instagram: '',
  videos: [],
  error: '',
};
export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    setMediaStateDefault: () => {
      return { ...initialState };
    },
    startProcessingMedia: state => {
      state.inProgress = true;
    },
    setProfileImage: (state, action: PayloadAction<ImageInfo | null>) => {
      state.profile = action.payload;
    },
    setAdditionalImages: (state, action: PayloadAction<AdditionalMedia[]>) => {
      state.additional = action.payload;
    },
    setInstagramUrl: (state, action) => {
      state.instagram = action.payload;
    },
    setVideos: (state, action: PayloadAction<VideoMedia[]>) => {
      state.videos = action.payload;
    },
    addVideoUrl: (state, action) => {
      state.videos = immaHelpers.update(state.videos, action.payload);
    },
    removeVideoUrl: (state, action) => {
      state.videos = immaHelpers.remove(state.videos, action.payload);
    },
    submitMedia: state => {
      state.inProgress = false;
      state.isDone = true;
      state.doRedirectFurther = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(confirmMediaStep.fulfilled, state => {
      state.error = '';
      state.doRedirectFurther = true;
    });
    builder.addCase(confirmMediaStep.pending, state => {
      state.error = '';
    });
    builder.addCase(confirmMediaStep.rejected, (state, action) => {
      state.error = httpErrorHandling(action);
    });
  },
});

export const {
  setMediaStateDefault,
  startProcessingMedia,
  setProfileImage,
  setAdditionalImages,
  setInstagramUrl,
  setVideos,
  addVideoUrl,
  removeVideoUrl,
  submitMedia,
} = mediaSlice.actions;

export default mediaSlice.reducer;
